import React, { Component } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Breadcrumb, BreadcrumbItem, Col, Row } from "reactstrap"

class Breadcrumbs extends Component {
  render() {
    return (
      <React.Fragment>
        <Row>
          <Col xs="12">
            <div className="ms-3">
              <Row className="page-title-box d-flex ">
                <h4 className="mb-0 font-size-18">
                  {this.props.breadcrumbItem}
                </h4>
              </Row>
              <Row className="page-title-box d-flex ">
                <div className="page-title-right">
                  <Breadcrumb listClassName="m-0">
                    <BreadcrumbItem>
                      <Link to="/dashboard">{this.props.title}</Link>
                    </BreadcrumbItem>
                    <BreadcrumbItem active>
                      <Link to="#">{this.props.breadcrumbItem}</Link>
                    </BreadcrumbItem>
                  </Breadcrumb>
                </div>
              </Row>
            </div>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}

Breadcrumbs.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
}

export default Breadcrumbs
